import { Typography, Button, Box } from "@mui/material";
import { useNavigate } from "react-router-dom";

function KanbanEmptyState({ projectId }) {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/issuesflag/${projectId}`);
  };

  return (
    <Box textAlign="center" mt={4}>
      <Typography variant="h6" gutterBottom>
        You haven&apos;t set up a Kanban view for this project yet.
      </Typography>
      <Typography variant="body1" gutterBottom>
        To manage and track your reports efficiently, please create a Kanban view.
      </Typography>
      <Button variant="contained" color="primary" sx={{ mt: 2 }} onClick={handleNavigate}>
        Create Kanban View
      </Button>
    </Box>
  );
}

export default KanbanEmptyState;
